// extracted by mini-css-extract-plugin
export default {"root":"SubmitButton_root__Q0VNH","isLoadingText":"SubmitButton_isLoadingText__7vEoK","loader":"SubmitButton_loader__Sz9bT"};